export const localStorageKeys = {
    token:'ol_token',
    refresh_token:'ol_refresh_token',
    user:'ol_user',
    user_remind_me:"ol_remind_me"
}